import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Dropdown, Divider } from "antd";
import { Link } from "react-router-dom";
import useModalToggle from "../../../custom_hooks/useModalToggle";
import CategoryAdd from "./modal/CategoryAdd";
import toast from "react-hot-toast";
import Search from "../../../components/Search";
import ConfirmModal from "../../../components/ConfirmModal";
import CardLoading from "../../../components/CardLoading";
import svg56 from "../../../assets/svg/svg56.svg";
import svg27 from "../../../assets/svg/svg27.svg";
import svg69 from "../../../assets/svg/svg69.svg";
import deleteSvg from "../../../assets/svg/delete-red.svg";
import BreadCrumb from "../../../layout/BreadCrumb";
import { fetchData } from "../../../features/fetch/fetchSlice";
import { deleteRequest } from "../../../features/save/saveSlice";

function CategoryTable() {
  const dispatch = useDispatch();
  const url = "api/v1/payments/fetch-payment-categories";
  const [searchInput, setSearchInput] = useState("");
  const [prodd, setProdd] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const { open, handleOpen, handleCancel } = useModalToggle();

  const { saving } = useSelector((state) => state.save);
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const handleSearch = (e) => {
    setSearchInput(e.target.value);
    dispatch(fetchData({ url, ["pcName"]: e.target.value || null }));
  };

  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      deleteRequest({
        url: `api/v1/payments/delete-payment-category/${prodd?.pcId}`,
      })
    );
    if (res?.payload?.success) {
      toast.success(res?.payload?.messages?.message);
      setOpenDelete(false);
      fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleEdit = async () => {
    handleOpen();
  };

  const handleAdd = () => {
    setProdd(null);
    handleOpen();
  };
  const settingItems = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleEdit}
          className="flex gap-x-[.75rem] items-center py-[.5rem] font-dmSans"
        >
          <img src={svg69} alt="svg69" className="w-4 h-4" />
          <span className="whitespace-nowrap">Edit</span>
        </Link>
      ),
    },
    {
      key: "divider-1",
      type: "divider",
    },
    {
      key: "2",
      label: (
        <Link
          onClick={handleOpenDelete}
          className="flex gap-x-[.75rem] items-center py-[.5rem] font-dmSans"
        >
          <img src={deleteSvg} alt="deleteSvg" className="w-4 h-4" />
          <span className="whitespace-nowrap">Delete</span>
        </Link>
      ),
    },
    {
      key: "divider-2",
      type: "divider",
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: "3%",
      render: (_, __, i) => i + 1,
    },
    { title: "Name", dataIndex: "pcName" },

    {
      title: "Actions",
      render: (item) => (
        <>
          {!item?.orgOwned ? null : (
            <Dropdown
              overlayStyle={{
                width: "250px",
              }}
              trigger={"click"}
              menu={{ items: settingItems }}
              placement="bottom"
            >
              <button onClick={() => setProdd(item)}>
                <img src={svg27} alt="svg27" />
              </button>
            </Dropdown>
          )}
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const fetchTableData = (page = pageIndex, size = pageSize) => {
    dispatch(fetchData({ url, start: page, limit: size }));
  };

  useEffect(() => {
    fetchTableData();
  }, []);

  const breadList = [
    {
      title: (
        <div className="flex items-center gap-[.25rem]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <g clipPath="url(#clip0_627_13942)">
              <path
                d="M13.7899 6.89067L7.75241 0.856289L7.34772 0.451602C7.25551 0.360003 7.13082 0.308594 7.00085 0.308594C6.87087 0.308594 6.74618 0.360003 6.65397 0.451602L0.211783 6.89067C0.117301 6.98478 0.0426296 7.09687 -0.00782254 7.22031C-0.0582747 7.34376 -0.0834854 7.47607 -0.0819665 7.60942C-0.0757165 8.15942 0.382096 8.59848 0.932096 8.59848H1.59616V13.6875H12.4055V8.59848H13.0837C13.3508 8.59848 13.6024 8.49379 13.7915 8.30473C13.8846 8.21193 13.9583 8.10159 14.0085 7.98009C14.0586 7.8586 14.0842 7.72836 14.0837 7.59692C14.0837 7.33129 13.979 7.07973 13.7899 6.89067ZM7.87585 12.5625H6.12585V9.37504H7.87585V12.5625ZM11.2805 7.47348V12.5625H8.87585V9.00004C8.87585 8.65473 8.59616 8.37504 8.25085 8.37504H5.75085C5.40553 8.37504 5.12585 8.65473 5.12585 9.00004V12.5625H2.72116V7.47348H1.22116L7.00241 1.69691L7.36335 2.05785L12.7821 7.47348H11.2805Z"
                fill="black"
                fillOpacity="0.45"
              />
            </g>
            <defs>
              <clipPath id="clip0_627_13942">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>Home</span>
        </div>
      ),
      href: "/#/dashboard",
    },
    {
      title: <div className="text-lighGold text-[16px]">Category Setup</div>,
    },
  ];

  if (loading && !searchInput) return <CardLoading />;

  return (
    <div className="w-full h-full overflow-y-scroll">
      <div className="justify-between items-center white_card">
        <BreadCrumb
          breadList={breadList}
          header={"Payment Category"}
          info={"Manage your payment categories here"}
          btn={false}
        />
      </div>
      <div className="white_card mt-[1.25rem] min-h-[70vh] flex-1 flex-col">
        <h3 className="heading_4">Category Setup</h3>
        <div className="flex flex-wrap items-center lg:justify-end justify-start gap-[.62rem]">
          <div className="lg:w-[16.125rem] w-full">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text="Search"
            />
          </div>
          <div className="w-[200px]">
            <button onClick={handleAdd} className="cstm-btn-2">
              <img src={svg56} alt="add" />
              <span className="ml-1">Add Category</span>
            </button>
          </div>
        </div>
        {loading ? (
          <CardLoading />
        ) : (
          <Table
            className="mt-[1.31rem] w-full"
            scroll={{ x: "auto" }}
            rowKey={(record) => record?.pcId}
            columns={columns}
            dataSource={data}
            pagination={{
              position: ["bottomCenter"],
              current: pageIndex + 1,
              total: count,
              pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchTableData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        )}
      </div>

      <CategoryAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={saving}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </div>
  );
}

export default CategoryTable;
